import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocalStorage } from "../../store/mahutiLocalStorage";
import { setCartDiscountRate, setCustomerDetails, setIsStepFourLoading, setOpportunity, setShouldBFocusError } from "../../store/MahutiReducer";
import { getAmount, patchOpportunitySF } from "../../utils/sfUtils";
import MahutiInputText from "../mahuti-input-text/MahutiInputText";
import { PAYMENT_IN_PROCESS, scrollToSection } from "../../utils/GlobalParams";
import './CustomerDetails.css'
import { Link } from "react-router-dom";
import { isMobile } from "react-device-detect";


function CustomerDetails(props) {
    const store = useSelector(store => store.reducer);
    const [getLocalStorage, setLocalStorage] = useLocalStorage();
    const dispatch = useDispatch();
    const [errors, setErrors] = useState({})
    const [fields, setFields] = useState({})
    const [couponLoader, setCouponLoader] = useState(false)
    const opportunityId = store.opportunity?.id;
    let customerDetailObj =  getLocalStorage('customerDetails') ? getLocalStorage('customerDetails') : {};
    const customerFormErrors = store.customerFormErrors

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault(); // מניעת שליחת טופס
            setCustomerState({ target: { checked: !store.customerDetails.approvingCondition } }, 'approvingCondition');
        }
    };

    useEffect(()=> {
        if(customerDetailObj) {
            dispatch(setCustomerDetails(customerDetailObj));
        }
    },[])

    const setCustomerState = (value, customerDetailKey) => {
        if(customerDetailKey === 'approvingCondition'){
            value = value.target.checked
        }
        if(customerDetailKey === 'email'){
            value = value.toLowerCase()
        }
        customerDetailObj = store.customerDetails
        customerDetailObj = {...customerDetailObj, [customerDetailKey]: value};
        setLocalStorage('customerDetails', customerDetailObj);
        dispatch(setCustomerDetails(customerDetailObj));
    }

    const setCoupon = (e) => {
        e.preventDefault();
        if(customerDetailObj.codeCoupon){
            setCouponLoader(true)
            dispatch(setIsStepFourLoading(true));
            patchOpportunitySF(customerDetailObj.codeCoupon, opportunityId,PAYMENT_IN_PROCESS, store.customerDetails, false).then(res => {
                let discountAmount = res.data.discount;
                dispatch(setOpportunity({ amount: res.data.amount, discount: discountAmount }));
                if (res.data.discountRate && res.data.discountRate > 0) {
                    dispatch(setCartDiscountRate(res.data.discountRate));
                    // הודעת הצלחה לקוראי מסך
                    const successMessage = `הקופון ${customerDetailObj.codeCoupon} מומש בהצלחה. התקבלה הנחה של ${res.data.discountRate}%`;
                    setErrors({
                        ...errors, 
                        coupon: undefined,
                        success: successMessage
                    });
                    // הוספת הודעה שתיעלם אחרי 5 שניות
                    setTimeout(() => {
                        setErrors(prev => ({...prev, success: undefined}));
                    }, 5000);
                }
            })
            .catch(() => {
                const errorMessage = `הקופון ${customerDetailObj.codeCoupon} אינו תקין או שפג תוקפו`;
                setErrors({
                    ...errors, 
                    coupon: errorMessage,
                    success: undefined
                });
            })
            .finally(() => {
                dispatch(setIsStepFourLoading(false));
                setCouponLoader(false)
            })
        }
    }

    // Add refs for input fields
    const inputRefs = {
        firstName: useRef(null),
        lastName: useRef(null),
        phoneNumber: useRef(null),
        email: useRef(null),
        city: useRef(null),
        approvingCondition: useRef(null)
    };

    const handleSubmit = (e) => {
        e.preventDefault();
    };

    // Listen to form errors changes and focus first error
    useEffect(() => {
        if (store.shouldBFocusError && customerFormErrors && Object.keys(customerFormErrors).length > 0) {
            const firstErrorField = Object.keys(customerFormErrors)[0];
            
            if (inputRefs[firstErrorField]?.current) {
                // נוסיף timeout קצר כדי לוודא שהדום התעדכן
                setTimeout(() => {
                    
                    inputRefs[firstErrorField].current.focus();
                    inputRefs[firstErrorField].current.scrollIntoView({ 
                        behavior: 'smooth', 
                        block: 'center' 
                    });
                }, 0);
                // Reset the flag after focusing
                dispatch(setShouldBFocusError(false));
            }
        }
    }, [customerFormErrors]);

    return  <form 
                className="customerDetails mt-1" 
                aria-label="רגע לפני הרכישה, פרטי המזמין"
                onSubmit={handleSubmit}
                noValidate
            >   
                <h3 className={`text-start customer_details_title mt-lg-4 mb-1 mt-1 ${isMobile ? 'almoni_tzar_bold' : 'almoni_tzar_normal'}`}> פרטי המזמין:</h3>
                <div className="required-fields-legend text-start mb-3">
                    <small className="text-muted">
                         שדה חובה  <span className="text-danger ms-1">*</span>
                    </small>
                </div>
                <div className="pb-4">
                    <div className="row gx-0 gx-lg-3">
                        <div className={`col-lg-6 col-12 relative ${isMobile && 'pb-4'}`}>
                            <div id="firstName_scroll" className="scroll_div"></div>
                            <MahutiInputText 
                                error={customerFormErrors.firstName ? 'error' : ''} 
                                defaultValue={customerDetailObj?.firstName || ''} 
                                onChange={setCustomerState} 
                                label='שם פרטי' 
                                id='firstName'
                                ref={inputRefs.firstName}
                                ariaDescribedby={customerFormErrors.firstName ? "firstName-error" : undefined}
                                ariaInvalid={customerFormErrors.firstName ? "true" : "false"}
                                required
                            />
                            {customerFormErrors.firstName && 
                            <div id="firstName-error" className="input_alert" role="alert">
                                {customerFormErrors.firstName}
                            </div>}
                        </div>
                        <div className="col-lg-6 col-12 relative">
                            <div id="lastName_scroll" className="scroll_div"></div>
                            <MahutiInputText 
                                error={customerFormErrors.lastName ? 'error' : ''} 
                                defaultValue={customerDetailObj?.lastName || ''} 
                                onChange={setCustomerState} 
                                label='שם משפחה' 
                                id='lastName'
                                ref={inputRefs.lastName}
                                ariaDescribedby={customerFormErrors.lastName ? "lastName-error" : undefined}
                                ariaInvalid={customerFormErrors.lastName ? "true" : "false"}
                                required
                            />
                            {customerFormErrors.lastName && 
                                <div id="lastName-error" className="input_alert" role="alert">
                                    {customerFormErrors.lastName}
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div className="">
                    <div className="">
                        <div className="pb-4 relative">
                            <div id="phoneNumber_scroll" className="scroll_div"></div>
                            <MahutiInputText 
                                error={customerFormErrors.phoneNumber ? 'error' : ''} 
                                defaultValue={customerDetailObj?.phoneNumber || ''} 
                                onChange={setCustomerState} 
                                label='טלפון' 
                                id='phoneNumber'
                                ref={inputRefs.phoneNumber}
                                ariaDescribedby={customerFormErrors.phoneNumber ? "phone-error" : undefined}
                                ariaInvalid={customerFormErrors.phoneNumber ? "true" : "false"}
                                required
                            />
                            {customerFormErrors.phoneNumber && 
                                <div id="phone-error" className="input_alert" role="alert">
                                    {customerFormErrors.phoneNumber}
                                </div>
                            }
                        </div>
                        <div className="pb-4 relative">
                            <div id="email_scroll" className="scroll_div"></div>
                            <MahutiInputText 
                                error={customerFormErrors.email ? 'error' : ''} 
                                defaultValue={customerDetailObj?.email || ''} 
                                type='email' 
                                onChange={setCustomerState} 
                                label='אימייל' 
                                id='email'
                                ref={inputRefs.email}
                                ariaDescribedby={customerFormErrors.email ? "email-error" : undefined}
                                ariaInvalid={customerFormErrors.email ? "true" : "false"}
                                required
                            />
                            {customerFormErrors.email && 
                                <div id="email-error" className="input_alert" role="alert">
                                    {customerFormErrors.email}
                                </div>
                            }
                        </div>

                        <div className="pb-4 relative">
                            <div id="companyName_scroll" className="scroll_div"></div>
                            <MahutiInputText 
                                defaultValue={customerDetailObj?.companyName || ''} 
                                onChange={setCustomerState} 
                                label='חברה' 
                                id='companyName' 
                            />
                        </div>
                        <div className="pb-4 relative">
                            <div id="city_scroll" className="scroll_div"></div>
                            <MahutiInputText 
                                error={customerFormErrors.city ? 'error' : ''} 
                                defaultValue={customerDetailObj?.city || ''} 
                                label='עיר' 
                                onChange={setCustomerState} 
                                id='city'
                                ref={inputRefs.city}
                                ariaDescribedby={customerFormErrors.city ? "city-error" : undefined}
                                ariaInvalid={customerFormErrors.city ? "true" : "false"}
                                required
                            />
                            {customerFormErrors.city && 
                                <div id="city-error" className="input_alert" role="alert">
                                    {customerFormErrors.city}
                                </div>
                            }
                        </div>
                        <div className="pb-4">
                            <div className="row flex-grow-1">
                                <div className="col-8 d-flex flex-column">
                                    <MahutiInputText 
                                        error={errors.coupon ? 'error' : ''} 
                                        defaultValue={customerDetailObj?.codeCoupon || ''} 
                                        id='codeCoupon' 
                                        label='הזן קוד קופון' 
                                        onChange={setCustomerState}
                                        ariaDescribedby={errors.coupon ? "coupon-error" : (errors.success ? "coupon-success" : undefined)}
                                        ariaInvalid={errors.coupon ? "true" : "false"}
                                    />
                                   {errors.coupon && 
                                        <div id="coupon-error" className="input_alert" role="alert">
                                            {errors.coupon}
                                        </div>
                                    }
                                    {errors.success && 
                                        <div id="coupon-success" className="alef success_message" role="alert" >
                                            {errors.success}
                                        </div>
                                    }
                                    {store.cartDiscountAmount > 0 && !errors.success && 
                                        <div className="tiny_msg" role="alert" >
                                            קופון אושר
                                        </div>
                                    }
                                </div>
                                <div className="col-4">
                                    <button 
                                        className="form-control btn-mahuty-light text-mahuti rounded-0 d-flex justify-content-center align-items-center" 
                                        type='button' 
                                        onClick={(e) => setCoupon(e)} 
                                        disabled={store.isStepFourLoading || store.cartDiscountAmount > 0}
                                        aria-label="ממש קופון"
                                    >
                                        ממש קופון
                                        {couponLoader && 
                                            <span 
                                                className="spinner-border spinner-border-sm ms-2" 
                                                role="status" 
                                                aria-label="בטעינה"
                                            />
                                        }
                                    </button>
                                </div>

                            </div>
                        </div>

                        <div className={`d-flex alef mb-2 ${customerFormErrors.approvingCondition ? 'checkbox_error_frame' : ''}`}>
                            <div className="form-check ps-0 align-items-center d-flex relative">
                                <div id="approvingCondition_scroll" className="scroll_div"></div>
                                <input 
                                    className={`pointer form-check-input fa ${customerFormErrors.approvingCondition ? 'error' : ''}`} 
                                    checked={Boolean(store.customerDetails.approvingCondition)} 
                                    type="checkbox" 
                                    id="approvingCondition" 
                                    onChange={(e) => setCustomerState(e, 'approvingCondition')}
                                    onKeyDown={handleKeyDown}  // הוספת טיפול במקש Enter
                                    ref={inputRefs.approvingCondition}
                                    aria-describedby={customerFormErrors.approvingCondition ? "approvingCondition-error" : undefined}
                                    aria-invalid={customerFormErrors.approvingCondition ? "true" : "false"}
                                />
                                <label className="form-check-label ps-2 form-text mt-0" htmlFor="approvingCondition">
                                    <span>קראתי ואני מסכים </span>
                                    <Link className="btn-link" to="https://www.mahuti.co.il/terms/">לתנאי השימוש</Link>
                                </label>
                            </div>
                        </div>
                        {customerFormErrors.approvingCondition && 
                            <div id="approvingCondition-error" className="input_alert" role="alert">
                                {customerFormErrors.approvingCondition}
                            </div>
                        }

                        <div className="pb-4 pt-2">
                            <ul className="form-group alef list-unstyled mb-0">
                                <li className="d-flex mb-1">
                                    <small>- התשלום באמצעות כרטיס אשראי</small>
                                </li>
                                <li className={`${isMobile ? 'd-block text-start' : 'd-flex'}`}>
                                    <small>
                                        - הפרטים שלך ישמשו רק עבור רישום ותמיכה באתר בהתאם 
                                        <Link className="btn-link ps-1" to="https://www.mahuti.co.il/privacy/">
                                            למדיניות פרטיות שלנו
                                        </Link>
                                    </small>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </form>
}


export default CustomerDetails;